<style>
	.outlined {
		text-shadow:
			-1px -1px 0 #000,
			0 -1px 0 #000,
			1px -1px 0 #000,
			1px 0 0 #000,
			1px 1px 0 #000,
			0 1px 0 #000,
			-1px 1px 0 #000,
			-1px 0 0 #000;
	}
</style>

<span class="outlined" role="timer" aria-label="recording timer">
	<sim-timer-display
		[relativeTime]="scenarioRecordingTime"
		[startDate]="scenarioRecording?.start"
		[showAbsoluteTimeOverride]="showAbsoluteTimeOverride"
	/>
</span>
